export class LoginSessionExpired {
  static FLAG = "login-session-expired-flag";

  static raiseFlag() {
    sessionStorage.setItem(LoginSessionExpired.FLAG, "true");
  }

  static isRaised(): boolean {
    return sessionStorage.getItem(LoginSessionExpired.FLAG) === "true";
  }

  static lowerFlag() {
    sessionStorage.removeItem(LoginSessionExpired.FLAG);
  }
}
